import { useRouteMatch, useParams } from "react-router-dom"

import { useScenarioType } from "../ScenarioTypeContext"

import InterventionsEditorLayout from "./InterventionEditorLayout"

import AddEntity from "../AddEntity"
import InlineEditor from "../InlineEditor"

import { genInterventionMenuCategoryRec } from "./types"
import { getIntvMenusBC } from "../urls"
import { swapDown, swapUp } from "../utils"

const InterventionsMenu = () => {
    const params = useParams()
    const {url} = useRouteMatch()
    const {
        scenarioType,
        intvMenuCategories,
        intvMenuItems,
        uniqueIDs,
        uniqueLabels
    } = useScenarioType()

    const addIntvMenuCategory = (entityType, newID, newLabel) => intvMenuCategories.add(genInterventionMenuCategoryRec(newID, newLabel))

    const moveCatUp = (idx) => intvMenuCategories.reorder(swapUp(scenarioType.interventionMenuCategories, idx))

    const moveCatDown = (idx) => intvMenuCategories.reorder(swapDown(scenarioType.interventionMenuCategories, idx))

    const onDeleteCategory = (item) => {
        console.log(`onDelete(${JSON.stringify(item)})`)
        const myMenuItems = scenarioType.interventionMenuItems.filter(e => e.intvCategoryID === item.id)
        let msg = `Are you sure you wish to delete menu category ${item.label} and it's children?\n`
        if (myMenuItems.length > 0) {
            msg += '\nMenu Items:\n'
            msg += myMenuItems.map(mi => mi.label).join('\n')
        }
        if (window.confirm(msg)) {
            myMenuItems.forEach(e => intvMenuItems.remove(e.id))
            intvMenuCategories.remove(item.id)
        }
    }

    return (
        <InterventionsEditorLayout
            breadcrumbs = {
                [getIntvMenusBC(params)]
            }
        >
            <InlineEditor
                heading="Intervention Menu Categories"
                records={scenarioType.interventionMenuCategories}
                allowChangeOrder={true}
                onMoveUp={moveCatUp}
                onMoveDown={moveCatDown}
                editLink={true}
                editBaseURL={url}
                onDelete={onDeleteCategory}
            >
                <AddEntity
                    entitiesDesc={[{type: "interventioMenuCategory", name: "Intervention Menu Category", labelsUnique: false}]}
                    addHandler={addIntvMenuCategory}
                    uniqueIDs={uniqueIDs}
                    uniqueLabels={uniqueLabels}
                />
            </InlineEditor>
        </InterventionsEditorLayout>
    )
}

export default InterventionsMenu